"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var Highlight2_exports = {};
__export(Highlight2_exports, {
  default: () => Highlight2_default
});
module.exports = __toCommonJS(Highlight2_exports);
var React = __toESM(require("react"));
var import_styled_components = __toESM(require("styled-components"));
const SvgIcon = ({
  title,
  titleId,
  desc,
  descId,
  iconSize,
  ariaHidden,
  ...props
}) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    ...props,
    viewBox: "0 0 21 20",
    fill: "currentColor",
    color: "currentColor",
    role: "img",
    "aria-labelledby": titleId,
    "aria-describedby": descId
  },
  desc ? /* @__PURE__ */ React.createElement("desc", { id: descId }, desc) : null,
  title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null,
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M4.69922 12.75C4.59505 12.5938 4.54948 12.4245 4.5625 12.2422C4.58854 12.0469 4.66667 11.8841 4.79688 11.7539L12.2578 3.62891C12.7266 3.12109 13.2995 2.80859 13.9766 2.69141C14.6536 2.5612 15.2982 2.65234 15.9102 2.96484C16.8477 3.42057 17.401 4.16276 17.5703 5.19141C17.7526 6.22005 17.4792 7.10547 16.75 7.84766L8.99609 15.8945C8.83984 16.0638 8.64453 16.1484 8.41016 16.1484C8.17578 16.1484 7.98047 16.0638 7.82422 15.8945L7.76562 15.8555L6.41797 16.7148C6.33984 16.7669 6.2487 16.806 6.14453 16.832C6.05339 16.8451 5.96224 16.8516 5.87109 16.8516L4.71875 17.7109C4.70573 17.724 4.6862 17.737 4.66016 17.75C4.64714 17.75 4.6276 17.75 4.60156 17.75H2.84375C2.79167 17.75 2.74609 17.724 2.70703 17.6719C2.68099 17.6198 2.68099 17.5677 2.70703 17.5156L3.89844 15.1328C3.76823 14.9896 3.6901 14.8268 3.66406 14.6445C3.65104 14.4492 3.69661 14.2669 3.80078 14.0977L4.69922 12.75ZM5.63672 12.3008L8.41016 15.0547L16.0273 7.16406C16.5221 6.65625 16.7044 6.05729 16.5742 5.36719C16.457 4.66406 16.0859 4.15625 15.4609 3.84375C15.0443 3.63542 14.6081 3.57682 14.1523 3.66797C13.6966 3.74609 13.3125 3.96094 13 4.3125L5.63672 12.3008ZM5.28516 13.375L4.50391 14.5664L5.96875 16.0117L7.16016 15.25L5.28516 13.375ZM4.48438 15.8164L3.9375 16.9102H4.38672L5.07031 16.4023L4.48438 15.8164ZM7.58984 16.832C7.44661 16.832 7.32292 16.8841 7.21875 16.9883C7.1276 17.0794 7.08203 17.1966 7.08203 17.3398C7.08203 17.4701 7.1276 17.5872 7.21875 17.6914C7.32292 17.7826 7.44661 17.8281 7.58984 17.8281H17.5898C17.7201 17.8281 17.8307 17.7826 17.9219 17.6914C18.026 17.5872 18.0781 17.4701 18.0781 17.3398C18.0781 17.1966 18.026 17.0794 17.9219 16.9883C17.8307 16.8841 17.7201 16.832 17.5898 16.832H7.58984Z",
      fill: "currentColor"
    }
  )
);
const SvgHighlight2 = (0, import_styled_components.default)(SvgIcon)(({ iconSize, color }) => {
  const getIconSize = () => {
    const standardIconSize = {
      s: "17px",
      // 17px small
      m: "20px",
      // 20px medium
      l: "24px",
      // 24px large
      xl: "32px",
      // 32px extraLarge
      inherit: "inherit"
      // inherits size from parent
    };
    return standardIconSize[iconSize];
  };
  return import_styled_components.css`
    width: ${getIconSize()};
    height: ${getIconSize()};
    display: inline-block;
    color: ${color};
  `;
});
var Highlight2_default = SvgHighlight2;
